module.exports = __webpack_public_path__ + "media/newstyle/images/lock-61af32eee45d53cb4ba28132e0105ede.svg";